/**
 * Input Schema of AdminConfig
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {AdminConfig} from '@/model/resource/AdminConfig'
import PasswordConfirm from '@/components/PasswordConfirm.vue'

/* TODO: review generated schema */
export class InputAdminConfigSchema extends Schema {
  readonly name = 'InputAdminConfig'

  passwordFields = [
    'senhaApp',
    'repetirSenhaApp',
    'senhaPainel',
    'repetirSenhaPainel',
  ]

  mainFields = [
    'raioAuditoriaCheckinMetros',
    'raioAuditoriaEntregaMetros',
    'autorizarMesmoVencido',
    'utilizarSmsZenvia',
    'salvarLogsRequestSSW',
    'permitirNotificacaoEmailAtlas',
    'permitirNotificacaoSmsAtlas',
  ]

  isSenhaAppMatch: boolean | null = null
  isSenhaPainelMatch: boolean | null = null

  readonly fieldSet: FieldSet<AdminConfig> = {
    boasVindas: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'textarea',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    raioAuditoriaCheckinMetros: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        label: this.translateFrom(schema.fieldName),
        class: 'col-span-2 mb-8',
      },
    }),
    raioAuditoriaEntregaMetros: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        label: this.translateFrom(schema.fieldName),
        class: 'col-span-2 mb-8',
      },
    }),
    utilizarSmsZenvia: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center',
        labelClass: 'relative state',
      },
    }),
    salvarLogsRequestSSW: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center',
        labelClass: 'relative state',
      },
    }),
    senhaApp: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        label: this.translateFrom(schema.fieldName),
        type: 'password',
        minLength: 8,
        validation: 'min:8',
      },
    }),
    repetirSenhaApp: (schema): FieldComponent => ({
      is: PasswordConfirm,
      bind: {
        value: this.isSenhaAppMatch,
        label: this.translateFrom(schema.fieldName),
        password: schema.model.senhaApp,
        required: Boolean(schema.model.senhaApp),
      },
      on: {
        input: (val: boolean) => (this.isSenhaAppMatch = val),
      },
    }),
    senhaPainel: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        label: this.translateFrom(schema.fieldName),
        type: 'password',
        validation: 'min:8',
      },
    }),
    repetirSenhaPainel: (schema): FieldComponent => ({
      is: PasswordConfirm,
      bind: {
        value: this.isSenhaPainelMatch,
        label: this.translateFrom(schema.fieldName),
        password: schema.model.senhaPainel,
        required: Boolean(schema.model.senhaPainel),
      },
      on: {
        input: (val: boolean) => (this.isSenhaPainelMatch = val),
      },
    }),
    permitirNotificacaoEmailAtlas: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center',
        labelClass: 'relative state',
      },
    }),
    permitirNotificacaoSmsAtlas: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center',
        labelClass: 'relative state',
      },
    }),
  }
}
